/* eslint-disable space-before-function-paren */
import PluginCrypto from './pluginCrypto'
import { linkTo } from './linkHook'
import { imageUrlHook, hookAllImageUrl } from './imageUrlHook'

// js防抖
// 在事件被触发的n秒后执行回调，如果在这n秒内又被触发，则重新计时。
const debounce = (callback, delay) => {
  let timerId = null
  return function () {
    const that = this
    const args = arguments
    clearTimeout(timerId)
    timerId = setTimeout(() => {
      callback.apply(that, args)
    }, delay)
  }
}

// js节流
// 规定在一个单位时间内，只能触发一次函数。如果这个单位时间内触发多次函数，只有一次生效。
const throttle = (callback, delay) => {
  let last, timerId
  return function () {
    const that = this
    const args = arguments
    const now = new Date().getTime()
    if (last && now < last + delay) {
      clearTimeout(timerId)
      timerId = setTimeout(() => {
        last = now
        callback.apply(that, args)
      }, delay)
    } else {
      last = now
      callback.apply(that, args)
    }
  }
}

// 储存markdown a标签监听回调函数到window
const initDocumentListen = () => {
  window.listenDocument = (e) => {
    const elm = e.target
    const { tagName, hash, origin, href } = elm
    // markdown 锚点跳转
    if (tagName === 'A' && origin === window.location.origin && !!hash) {
      elm.dataset.hash = href
      elm.href = `javascript: (function() {
        const anchorElement = document.querySelector('${hash}');
        if (anchorElement) {
         anchorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        };
      })()`
    } else if (tagName === 'A' && !elm.dataset.hash) {
      elm.dataset.href || (elm.dataset.href = href)
      elm.href = 'javascript: void(0);'
      elm.setAttribute('target', '_self')
      window.open(elm.dataset.href, '_blank')
    }
  }
}

export {
  debounce,
  throttle,
  PluginCrypto,
  linkTo,
  initDocumentListen,
  imageUrlHook,
  hookAllImageUrl
}
